import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { useEffect, useState } from "react";
import { ImpactPlacesLinkModalModel } from "./ImpactPlacesLinkModal_model";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import { PlacesGrid } from "../../../PlacesGrid/PlacesGridView_view";

interface ImpactPlacesLinkModalViewProps {
  placeId?: number;
  impactId?: number;
  itemIds: number[];
  selectedLinkItemIds?: number[];
  onAssignSuccess?: (itemIds: number[]) => Promise<any>;
}

const ImpactPlacesLinkModalView: React.FC<ImpactPlacesLinkModalViewProps> = observer(
  ({ placeId, impactId, itemIds, selectedLinkItemIds, onAssignSuccess }) => {
    const { projectId } = useParams<{ projectId: string }>();
    const organisationId = useCurrentOrganisationId();
    const [model] = useState(
      () => new ImpactPlacesLinkModalModel(+organisationId, +projectId, itemIds, impactId, placeId)
    );

    useEffect(() => {
      model.onMount();
      return model.onUnmount;
    }, [model]);

    if (model.isLoading) return <PositionedSpinner />;

    return (
      <div className="d-flex flex-column h-100">
        <div className="d-flex flex-column unassigned-places-grid h-100">
          <div className="insight-tab-content__space-filler h-100">
            <PlacesGrid
              gridToolbarType="link-modal"
              onAssignSuccess={model.assignPlacesToImpacts || onAssignSuccess}
              data={model.places}
              isLoading={model.isLoading}
              columnDefs={model.placesColDefs}
              // refreshDataHandler={undefined}
              onFieldUpdate={model.showAllPlaces}
              placeGroupId={model.placeId}
              preSelectedItemIds={selectedLinkItemIds}
            />
          </div>
        </div>
      </div>
    );
  }
);

export { ImpactPlacesLinkModalView };
